import { render, staticRenderFns } from "./iconChat.vue?vue&type=template&id=6673ed7b"
import script from "./iconChat.vue?vue&type=script&lang=js"
export * from "./iconChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports